import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sv-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", { class: "sv-page-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "sv-page-header__eyebrow" }, "Plano e cobrança"),
    /*#__PURE__*/_createElementVNode("h1", null, "Pagamentos"),
    /*#__PURE__*/_createElementVNode("p", null, "Acompanhe o uso contratado, a forma de pagamento e o histórico de cobranças.")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckoutContent = _resolveComponent("CheckoutContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_CheckoutContent)
  ]))
}